import { render, staticRenderFns } from "./EmailSetting.vue?vue&type=template&id=31f38d58&scoped=true&"
import script from "./EmailSetting.vue?vue&type=script&lang=js&"
export * from "./EmailSetting.vue?vue&type=script&lang=js&"
import style0 from "./EmailSetting.vue?vue&type=style&index=0&id=31f38d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f38d58",
  null
  
)

export default component.exports